import { render } from "./pb-meritezuelen.vue?vue&type=template&id=2c9418f4"
import script from "./pb-meritezuelen.vue?vue&type=script&lang=js"
export * from "./pb-meritezuelen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__